var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Live_Area",
    display: "none"
  }, /*#__PURE__*/React.createElement("image", {
    display: "inline",
    width: 20,
    height: 20,
    xlinkHref: "9A15EDF7595F488.png",
    transform: "matrix(1 0 0 1 2 2)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    fill: "#000028",
    width: 20,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11,
    fill: "#000028",
    width: 13,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 17,
    fill: "#000028",
    width: 20,
    height: 2
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 24,
    height: 24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.b930f1ec1893f0c376cf5f0173b961a7.svg";
export { ForwardRef as ReactComponent };